export const seedPlayers = [
  {
    name: 'John Ulbright',
    image: require(`../assets/images/john_ulbright.png`),
    stats: { losses: 1 }
  },
  {
    name: 'Tyler McDonald',
    image: require('../assets/images/tyler_mcdonald.png'),
    stats: {}
  },
  {
    name: 'Jim Ott',
    image: require('../assets/images/jim_ott.png'),
    stats: { wins: 1 }
  },
  {
    name: 'Sam Nowakowski',
    image: require('../assets/images/sam_nowakowski.png'),
    stats: {}
  },
  {
    name: 'Andy Bachmann',
    image: require('../assets/images/andy_bachmann.png'),
    stats: {}
  }
] as SeedPlayer[]

export type SeedPlayer = {
  name: string
  image: string
  stats: {
    wins?: number
    losses?: number
  }
}

export type Player = {
  slug: string
  name: string
  image: string
  stats: {
    wins: number
    losses: number
  }
  birthdate: string
  city: string
  country: string
  bio: string
}
